{
  "feedback-internal-success-page": {
    "buttons": {
      "to-salon": "ĐẾN SALON"
    },
    "text": {
      "thanks": "Cảm ơn phản hồi của bạn",
      "thanks-again": "Phản hồi của bạn rất có giá trị để giúp chúng tôi cải thiện dịch vụ của mình"
    }
  }
}
